import React from 'react';
import styleService from '@nykaa/deals-utils/styles';
import Utils from '@nykaa/deals-utils/basic';
import styled from '../../../theme';
const { getPaddingStyles, getMarginStyles, getFontStyles } = styleService.utils;
const ProductPriceStyled = styled.div `
  ${({ margin }) => getMarginStyles(margin)};
  ${({ padding }) => getPaddingStyles(padding)};
  overflow: hidden;
  white-space: nowrap;
  display: block;
  text-overflow: ellipsis;
  .sale-price {
    ${({ salePriceText }) => getFontStyles(salePriceText)};
    display: inline;
  }
  .mrp-price {
    text-decoration: line-through;
    ${({ mrpPriceText }) => getFontStyles(mrpPriceText)};
    padding-top: 1px;
    margin: 0rem 0.25rem;
    display: inline;
  }
  .discounted-price {
    ${({ discountText }) => getFontStyles(discountText)};
    padding: 2px 0px 1px;
    display: inline;
  }
`;
const ProductPrice = ({ style, salePrice, discountedPrice, discountPercent, isCommaSeparated, }) => {
    const { commaSeparatedPrice, } = Utils;
    const transformPrice = (processedPrice) => Math.round(processedPrice);
    const transformedSalePrice = transformPrice(salePrice || 0);
    const transformedDiscountPrice = transformPrice(discountedPrice || 0);
    const isDiscount = transformedDiscountPrice - transformedSalePrice !== 0;
    return (React.createElement(ProductPriceStyled, { discountText: style.discountText, margin: style.margin, padding: style.padding, mrpPriceText: style.mrpPriceText, salePriceText: style.salePriceText },
        React.createElement("div", { className: "sale-price" },
            "\u20B9",
            isCommaSeparated ? (commaSeparatedPrice(transformedDiscountPrice.toString())) : transformedDiscountPrice),
        isDiscount && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "mrp-price" },
                "\u20B9",
                isCommaSeparated ? (commaSeparatedPrice(transformedSalePrice.toString())) : transformedSalePrice),
            React.createElement("div", { className: "discounted-price" }, `${discountPercent}%`)))));
};
export default ProductPrice;
